import Request from '@utils/ajax/http'
import ApiUrl from '../../config/index'
export default {
  namespaced: true,
  state: {
    // 开户信息
    openAccountData: {}
  },
  mutations: {
    updateOpenAccountData: (state, openAccountData) => {
      state.openAccountData = openAccountData
    }
  },
  actions: {
    bindCardInfo: ({
      commit
    }, params) => {
      return Request.post(ApiUrl.openaccount.queryP2pCard, params)
    },
    material: ({
      commit
    }, params) => {
      return Request.get(ApiUrl.material, {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/login/index.js